import type { AppVersionResponse } from '$lib/api/app-version';

export type AppVersionDetailsStatus = 'idle' | 'loading' | 'ready' | 'error';

type CreateAppVersionDetailsStateArgs = {
  load: () => Promise<AppVersionResponse>;
};

export function createAppVersionDetailsState(args: CreateAppVersionDetailsStateArgs) {
  return new AppVersionDetailsState(args.load);
}

class AppVersionDetailsState {
  private readonly load: () => Promise<AppVersionResponse>;
  private inFlight: Promise<void> | null = null;

  details = $state<AppVersionResponse | null>(null);
  status = $state<AppVersionDetailsStatus>('idle');

  constructor(load: () => Promise<AppVersionResponse>) {
    this.load = load;
  }

  refresh(): Promise<void> {
    if (this.inFlight) {
      return this.inFlight;
    }

    this.status = 'loading';
    const request = this.load()
      .then((details) => {
        this.details = details;
        this.status = 'ready';
      })
      .catch(() => {
        this.status = 'error';
      })
      .finally(() => {
        this.inFlight = null;
      });

    this.inFlight = request;
    return request;
  }
}
